import { Injectable } from "@angular/core";
import { UtilsBsHotToastService } from '../bs-toast/bs-toast.service';

@Injectable({
  providedIn: "root",
})
export class UtilsToastService {
  constructor(readonly toastService: UtilsBsHotToastService) {}

  show(message: string) {
    this.toastService.show(message);
  }

  showError(message: string) {
    this.toastService.showError(message);
  }

  showSuccess(message: string) {
    this.toastService.showSuccess(message);
  }

  showWarning(message: string) {
    this.toastService.showWarning(message);
  }

  showInfo(message: string) {
    this.toastService.showInfo(message);
  }

  showCustom<T>(message: string) {
    this.toastService.show(message);
  }
}
